/**
 * MarketingMaterials - Marketing materials info section (FULLY DYNAMIC)
 */
import { ExternalLink } from 'lucide-react';
import { getCampaignTheme, LEGACY_CAMPAIGN_NAMES } from './campaignUtils';

export default function MarketingMaterials({ report, allCampaigns }) {
  // Build dynamic campaign list from allCampaigns OR report.campaigns
  const campaignList = allCampaigns?.length > 0 
    ? allCampaigns 
    : report?.campaigns?.map(c => ({ campaign_id: c.campaign_id, title: c.title, description: c.description, theme: c.theme })) || [];

  // Default descriptions for legacy campaigns
  const legacyDescriptions = {
    1: '"Bulaccino Cafe — Join our coffee family!"',
    2: '"Real coffee. Fresh food. Island energy."',
    3: '"Bulaccino Cafe — Now Open!"',
    4: '"Welcome to Bulaccino — Exclusive Offer"'
  };

  return (
    <div className="mt-8 bg-primary/5 rounded-2xl p-6 border border-primary/20">
      <h3 className="font-heading text-lg text-foreground mb-4">Marketing Materials</h3>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {campaignList.map(campaignData => {
          const id = campaignData.campaign_id;
          const theme = getCampaignTheme(id, campaignData.theme);
          const campaignName = campaignData.title || LEGACY_CAMPAIGN_NAMES[id] || `Campaign ${id}`;
          const description = campaignData.description 
            ? `"${campaignData.description.slice(0, 60)}${campaignData.description.length > 60 ? '...' : ''}"`
            : legacyDescriptions[id] || '"Join our exclusive campaign"';

          return (
            <div key={id} className={`bg-card rounded-xl p-4 border ${theme.border}`} data-testid={`marketing-materials-campaign-${id}`}>
              <div className="flex items-center gap-2 mb-2">
                <div className={`w-6 h-6 rounded-full bg-gradient-to-r ${theme.gradient} flex items-center justify-center text-white text-xs font-bold`}>
                  {id}
                </div>
                <p className="font-medium text-foreground truncate">{campaignName}</p>
              </div>
              <p className="text-sm text-muted-foreground mb-3 line-clamp-2">{description}</p>
              <a 
                href={`/join/${id}`} 
                target="_blank" 
                rel="noreferrer" 
                className="text-primary text-sm hover:underline inline-flex items-center gap-1"
              >
                Preview Landing Page
                <ExternalLink className="w-3 h-3" />
              </a>
            </div>
          );
        })}
      </div>
      
      {campaignList.length === 0 && (
        <div className="text-center py-8 text-muted-foreground">
          <p>No campaigns found. Create a campaign to see marketing materials.</p>
        </div>
      )}
      
      <p className="text-sm text-muted-foreground mt-4">
        <strong>Coupon Validity:</strong> June 1 - 30, 2026 • 10% off every order • Ready for Twilio SMS & Mailchimp integration
      </p>
    </div>
  );
}
